import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useHelpCommon } from "@/pages-react/help/HelpCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout.tsx";

export const HelpDesktop = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useHelpCommon(props.content);

  return (
    <>
      {renderContent()}
    </>
  );
}, LayoutStyleTypes.TYPE_LG);
